import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';


// import { AgGridReact } from '@ag-grid-community/react';
// import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
// // import '@ag-grid-community/styles/ag-grid.css';
// // import '@ag-grid-community/styles/ag-theme-alpine.css';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
import * as LoginActivityController from './Controller/LoginActivityController';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../../GlobalModules/Login/Actions/LoginAction';
// import Utility from '../../../GlobalModules/Utility/Utility';
import Utility from '../../../../../Utility/Utility';
import ReactTooltip from 'react-tooltip';
import { DebounceInput } from 'react-debounce-input';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment-timezone';
// import Config from '../../../GlobalModules/Utility/Config';
import '../../Assets/css/loginactivity_doc.scss'
import Timezone from '../../../../../Utility/Timezone';
// import ErrorBoundary from '../../../../src/Utility/Components/ErrorBoundary';
// import GlobalHeaderFilter from '../../../../src/Utility/Components/GlobalHeaderFilter';
// import FilterContentSection from '../../../GlobalModules/Utility/Components/FilterContentSection';
class LoginActivity extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = {
            userName: "",
            organizationFilterSelectedData: "",
            userTypeList: [
                { label: "Admin", value: 'admin' },
                { label: "User", value: 'user' },
            ],
            user_type_filter: "",
            actionModalflag: false,
            modules: [InfiniteRowModelModule],
            columnDefs: [
                {
                    headerName: `Username`,
                    field: "user_name",
                    // ...this.getFieldDetails("user_name"), // for control pannel added
                    maxWidth: 300,
                    cellRenderer: (params) => {
                        if (params.data) {
                            if (params.data.hasOwnProperty('User') && params.data.User.first_name != "" && params.data.hasOwnProperty('User') && params.data.User.last_name != "") {
                                let concatUserName = `${params.data.User.first_name.trim().charAt(0).toUpperCase() + (params.data.User.first_name.trim()).slice(1)} ${params.data.User.last_name.trim().charAt(0).toUpperCase() + (params.data.User.last_name.trim()).slice(1)}`;
                                if (concatUserName.length > 15) {
                                    return <OverlayTrigger overlay={<ReactTooltip>{concatUserName}</ReactTooltip>}>
                                        <span >{concatUserName.substring(0, 10) + "..."}</span>
                                    </OverlayTrigger>
                                } else {
                                    return <span>{concatUserName}</span>
                                }
                            } else {
                                return null
                            }
                        } else {
                            return null
                        }
                    },
                },
                // {
                //     headerName: `Email`,
                //     field: "email",
                //     maxWidth: 300,
                //     cellRenderer: (params) => {
                //         if (params.data) {
                //             if (params.data.hasOwnProperty('User') && params.data.User.email != "" && params.data.User.email != null) {
                //                 if (params.data.User.email.length > 25) {
                //                     return <OverlayTrigger overlay={<Tooltip>{params.data.User.email}</Tooltip>}>
                //                         <span >{params.data.User.email.substring(0, 22) + "..."}</span>
                //                     </OverlayTrigger>
                //                 } else {
                //                     return <span>{params.data.User.email}</span>
                //                 }
                //             } else {
                //                 return null
                //             }
                //         } else {
                //             return null
                //         }
                //     },
                // },
                {
                    // headerName: `${this.props.t('loginTime')}`,
                    headerName: `Login Time`,
                    field: "login_time",
                    // ...this.getFieldDetails("login_time"), // for control pannel added
                    minWidth: 300,
                    cellRenderer: (params) => {
                        if (params.data) {
                            if (params.data.hasOwnProperty('login_time') && params.data.login_time != "" && params.data.login_time != null) {
                                return <span>{`${Timezone.formatDateUsingTimeZone(params.data.login_time, this.props.localTimeZoneName)} (${Timezone.getTimezoneName(this.props.localTimeZoneName)})`}</span>
                            } else {
                                return null
                            }
                        } else {
                            return null
                        }
                    },
                },
                {
                    // headerName: `${this.props.t('logoutTime')}`,
                    headerName: `Logout Time`,
                    field: "logout_time",
                    // ...this.getFieldDetails("logout_time"), // for control pannel added
                    minWidth: 300,
                    cellRenderer: (params) => {
                        if (params.data) {
                            if (params.data.hasOwnProperty('logout_time') && params.data.logout_time != "" && params.data.logout_time != null) {
                                return <span>{`${Timezone.formatDateUsingTimeZone(params.data.logout_time, this.props.localTimeZoneName)} (${Timezone.getTimezoneName(this.props.localTimeZoneName)})`}</span>
                            } else {
                                return null
                            }
                        } else {
                            return null
                        }
                    },
                },
                {
                    // headerName: `${this.props.t('logoutTime')}`,
                    headerName: `IP Address`,
                    field: "ip_address",
                    // ...this.getFieldDetails("ip_address"), // for control pannel added
                    minWidth: 300,
                    cellRenderer: (params) => {
                        if (params.data) {
                            if (params.data.hasOwnProperty('IpLocation') && params.data.IpLocation && params.data.IpLocation.hasOwnProperty('ip_address') && params.data.IpLocation.ip_address) {
                                return <span>{params.data.IpLocation.ip_address != "" ? params.data.IpLocation.ip_address : ""}</span>
                            } else {
                                return null
                            }
                        } else {
                            return null
                        }
                    },
                },
                {
                    // headerName: `${this.props.t('logoutTime')}`,
                    headerName: `Device Type`,
                    field: "device_type",
                    // ...this.getFieldDetails("device_type"), // for control pannel added
                    minWidth: 300,
                    cellRenderer: (params) => {
                        if (params.data) {
                            if (params.data.hasOwnProperty('Device') && params.data.Device && params.data.Device.hasOwnProperty('device_type') && params.data.Device.device_type) {
                                return <span>{params.data.Device.device_type != "" ? params.data.Device.device_type : ""}</span>
                            } else {
                                return null
                            }
                        } else {
                            return null
                        }
                    },
                }
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 90

            },
            components: {
                loadingRenderer: (params) => {
                    if (params.value !== undefined) {
                        return params.value;
                    } else {
                        return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
                    }
                },
            },
        },
            this.gridOptions = {
                infiniteInitialRowCount: 1,
                //onGridReady,
                paginationPageSize: 100,
                rowBuffer: 0,
                rowModelType: 'infinite',
                suppressCellSelection: true,
                suppressHorizontalScroll: true,
            }
        this.exportOutsideClickRef = React.createRef();
    }

    //========== for added control pannel ================//
    getFieldDetails = (fieldName) => {
        const fieldData = this.props.gridLableData.length > 0 ? this.props.gridLableData[0].setting_data.find(item => item.field_name == fieldName) : [];
        return {
            headerName: fieldData?.modified_field_caption || "",
            field: fieldName != "" ? fieldData?.field_name : "",
            hide: fieldData?.current_status != 1,
        };
    };
    //========== end for added control pannel ================//

    componentDidMount = () => {
        window.addEventListener('resize', this.handleResize);
        this.props.handleActiveLink("login_activities_module", "");
        document.body.addEventListener('mousedown', this.handleClickOutside.bind(this));
        if (this.props.userCredentials.user_details.user_type == 'admin' || "user") {
            this.setState({
                organizationFilterSelectedData: { "label": this.props.userCredentials.user_details.org_name, value: this.props.userCredentials.user_details.org_id }
            })
        }

        if (this.props.userCredentials.user_details.user_type == 'app_admin') {
            this.setState({
                organizationFilterSelectedData: { "label": 'All', value: 'all' }
            })
        }
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
        if (document.body) {
            document.body.removeEventListener('mousedown', this.handleClickOutside.bind(this));
        }
    }

    handleClickOutside(event) {
        if (this.exportOutsideClickRef.current != null) {
            if (this.exportOutsideClickRef && this.exportOutsideClickRef.current && !this.exportOutsideClickRef.current.contains(event.target)) {
                this.setState({
                    actionModalflag: false
                })
            }
        }

    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridparams = params;
        var datasource = this.serverSideDataSource()
        params.api.setDatasource(datasource);
    };

    serverSideDataSource = () => {
        let that = this
        return {
            getRows(params) {
                const { userName, organizationFilterSelectedData, user_type_filter } = that.state;
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse, userCredentials, userEntryType } = that.props;
                loaderStateTrue();
                let filters = {};
                let globalQueryParamshash = {};
                if (organizationFilterSelectedData != "" && organizationFilterSelectedData.value != 'all') {
                    globalQueryParamshash['org_id'] = organizationFilterSelectedData.value
                }
                if (user_type_filter != "") {
                    globalQueryParamshash['user_type'] = user_type_filter.value
                }
                if (userName.trim() != "") {
                    globalQueryParamshash['search_attr'] = userName.trim()
                    filters['filter_op'] = JSON.stringify({ "search_attr": "substring" })
                }
                globalQueryParamshash["offset"] = startRow;
                // globalQueryParamshash["limit"] = Config.pageDataLimit;
                globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);

                globalQueryParamshash["org_id"] = userEntryType?.org_id;
                filters['filters'] = JSON.stringify(globalQueryParamshash)
                LoginActivityController.loginDetailsListing(filters).then((response) => {
                    if (response.success) {
                        params.successCallback(response.data, response.total);
                        loaderStateFalse();
                    } else {
                        params.failCallback();
                        // Utility.toastNotifications(that.props.t('somethingWwrong'), "Error", "error")
                        Utility.toastNotifications("Something went wrong", "Error", "error");
                    }
                    loaderStateFalse();
                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                        Utility.toastNotifications(error.message, "Error", "error");
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {

                    }
                });
            }
        };
    }

    loadGrid = () => {
        this.resetDataGrid();
    }

    resetDataGrid = () => {
        this.gridparams.api.purgeInfiniteCache();
        var datasource = this.serverSideDataSource()
        this.gridparams.api.setDatasource(datasource);
    }

    handleChangeOrganizationFilter = (type, event) => {
        if (type == 'organization') {
            if (event) {
                this.setState({
                    organizationFilterSelectedData: event,
                }, () => {
                    this.resetDataGrid();
                })
            } else {
                this.setState({
                    organizationFilterSelectedData: "",
                    user_type_filter: ""
                }, () => {
                    this.gridparams.api.setDatasource([]);
                })
            }
        }
    }

    handleChangeUserFilter = (type, event) => {
        if (type == 'user_type_filter') {
            if (event) {
                this.setState({
                    user_type_filter: event,
                }, () => {
                    this.resetDataGrid();
                })
            } else {
                this.setState({
                    user_type_filter: "",
                }, () => {
                    this.resetDataGrid();
                })
            }

        }

    }

    handleUserSearchBar = (e) => {
        try {
            if (e.target.value.trim() !== this.state.userName.trim()) {
                this.setState({
                    userName: e.target.value
                }, () => {
                    this.resetDataGrid();
                })
            }
        } catch (error) {
            console.error("Error in handleUserSearchBar:", error)
        }
    }

    clearSearchValue = () => {
        this.setState({
            userName: ""
        }, () => {
            this.resetDataGrid()
        })
    }


    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type
        const { userName } = this.state
        return (
            <div className="gridcontainer" style={
                {
                    marginTop: '30px'
                }
            }>
                <div className="totalworkercontent">
                    <div className='filterSectionBox'>
                        <div className="gridtopviews gridtopviewsHistory">
                            <div className="pageinnersearchBox staff">
                                <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                                <DebounceInput
                                    minLength={2}
                                    debounceTimeout={500}
                                    onChange={(e) => this.handleUserSearchBar(e)}
                                    placeholder="Search by username"
                                    value={userName}
                                    autoComplete="off"
                                />
                                {userName.trim() != "" ?
                                    <button type="button" className="btn btn-link dropclosebtn" onClick={() => this.clearSearchValue()}>
                                        <img src={require('../../../../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                                    </button>
                                    : null}
                            </div>
                        </div>
                    </div>
                    <div className='grid_content_inner'>
                        <div className="ag-theme-alpine aggridview" style={{ position: 'relative' }}>
                            <div className="leadButtonInnerBox">
                                <button className="buttonload" onClick={() => { this.loadGrid() }} data-tip="Refresh data">
                                    <i className="fa fa-refresh"></i>
                                </button>
                                <ReactTooltip place="bottom" />
                            </div>
                            <AgGridReact
                                modules={this.state.modules}
                                columnDefs={this.state.columnDefs.map(colDef => ({
                                    ...colDef,
                                    cellClass: 'vertical_center'
                                }))}
                                defaultColDef={this.state.defaultColDef}
                                components={this.state.components}
                                rowSelection="single"
                                rowModelType="infinite"
                                onGridReady={this.onGridReady}
                                rowHeight={50}
                                headerHeight={47}
                                cacheBlockSize={parseInt(process.env.PAGE_DATA_LIMIT)}
                                gridOptions={this.gridOptions}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        // roleWisePermission: globalState.mainReducerData.roleWisePermission,
        // version: globalState.LoginReducer.version,
        localTimeZoneName: globalState.mainReducerData?.localTimeZone || 'Asia/Kolkata',
        userEntryType: globalState.LoginReducer.userEntryType,
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp })(LoginActivity);